export default "__VITE_ASSET__CTPvBkGy__"